import { SubscriptionService, useApiGetter } from '@localstack/services';

import {
  CIAuthToken,
  ComputeUsageSummary,
  LicenseAssignment,
  Permission,
  Subscription,
  UsageSummary,
} from '@localstack/types';

import { useAuthProvider } from './useAuthProvider';

type SubscriptionData = {
  subscriptions?: Array<Subscription>;
  usageData?: Record<string, UsageSummary>;
  ci_tokens?: Array<CIAuthToken>;
  licenseAssignments?: Array<LicenseAssignment>;
  computeUsage?: ComputeUsageSummary;
};

type SubscriptionOrchestratorReturnType = {
  data: SubscriptionData | null | undefined;
  isLoading: boolean;
};

export const useAggregatedSubscriptionInfo = (): SubscriptionOrchestratorReturnType => {
  const { can } = useAuthProvider();

  const { data, isLoading } = useApiGetter(SubscriptionService, 'getAggregatedSubscriptionInfo', [], {
    defaultValue: null,
    enable: can(Permission.READ_SUBSCRIPTIONS),
  });

  return { data, isLoading };
};
